import { useEffect, useRef } from 'react';
import useServiceDataControls from '../../useServiceData';
import createTimeout from '../../../utils/timeout/createTimeout';
import { isFunction } from 'lodash';
import { useService } from '../../../redux/reducer/service';
import { MILLISECONDS_FOR_CHANGE, THEME_KEY } from '../../../constants/shared/theme/settings';
import { ALL_THEMES, DEFAULT } from '../../../constants/shared/theme/names';

/**
 * Хук для контроля темой приложения
 */

export default function useTheme() {
  const { serviceData } = useService();

  // защита от закликивания
  const isAvailableChange = useRef(true);
  const timeoutClearRef = useRef();

  const currentTheme = serviceData?.[THEME_KEY] ?? DEFAULT;

  const { save } = useServiceDataControls();

  const set = (theme) => {
    if (!isAvailableChange.current || currentTheme === theme) return;

    if (!ALL_THEMES.includes(theme)) {
      console.warn(`submitted theme: ${theme} is not available`);
      return;
    }

    isAvailableChange.current = false;

    timeoutClearRef.current = createTimeout(() => {
      isAvailableChange.current = true;
      timeoutClearRef.current = null;
    }, MILLISECONDS_FOR_CHANGE);

    save(THEME_KEY, theme);
  };

  useEffect(() => () => isFunction(timeoutClearRef.current) && timeoutClearRef.current(), []);

  return { set, theme: currentTheme };
}
